import React from "react";
import Navbar, { MobileBottomBar } from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  return (
    <div className="App flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileBottomBar />
    </div>
  );
}

export function PageHeader({ overline, title, subtitle, children }) {
  return (
    <div className="relative overflow-hidden border-b border-gold-300/15 bg-ink-800">
      <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #D4AF37 0, transparent 40%)" }} />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-12 md:py-16">
        {overline && <div className="overline-label mb-3">{overline}</div>}
        <h1 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight leading-none text-white">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-3 max-w-2xl">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
